/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PreRegistrationDto } from '../../models/pre-registration-dto';

export interface PreRegistrationControllerFindAllV1$Params {
}

export function preRegistrationControllerFindAllV1(http: HttpClient, rootUrl: string, params?: PreRegistrationControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PreRegistrationDto>>> {
  const rb = new RequestBuilder(rootUrl, preRegistrationControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PreRegistrationDto>>;
    })
  );
}

preRegistrationControllerFindAllV1.PATH = '/api/v1/pre-registration';
